module.exports = __webpack_public_path__ + "654ee516645a1852fc54157ad855bae7.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-banners/banner-mushrooms.png
// module id = 2972
// module chunks = 0